(function () {
  'use strict';

  var SELECTORS = {
    popup: '[data-smart-cart-popup]',
    close: '[data-smart-cart-close]',
    items: '[data-smart-cart-items]',
    subtotal: '[data-smart-cart-subtotal]',
    discounts: '[data-smart-cart-discounts]',
    total: '[data-smart-cart-total]',
    totalRow: '[data-smart-cart-total-row]',
    compareTotal: '[data-smart-cart-compare-total]',
    savings: '[data-smart-cart-savings]',
    message: '[data-smart-cart-message]',
    recommendationsWrap: '[data-smart-cart-recommendations-wrap]',
    recommendationsGrid: '[data-smart-cart-recommendations]',
    qtyAction: '[data-smart-cart-qty-action]',
    retry: '[data-smart-cart-retry]'
  };

  var isAdding = false;
  var isChanging = false;
  var mutationObserver = null;
  var productJsonCache = {};
  var PURCHASE_BUTTON_SELECTOR = [
    '.smart-pdp-buy-stack .smart-pdp-add-button button',
    '.smart-pdp-buy-stack .smart-pdp-add-button .button',
    '.smart-pdp-buy-now-button',
    '.smart-pdp-add-to-cart-button',
    '.smart-sticky-add-to-cart-button',
    '.smart-sticky-add-to-cart-trigger',
    '.sticky-cart .shopify-product-form button',
    '.sticky-cart-action button',
    '.smart-product-card .add-to-cart',
    '.product-card .add-to-cart',
    'form[action*="/cart/add"] .add-to-cart',
    'form[action*="/cart/add"] button[name="add"]'
  ].join(',');

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function ajaxUrl(path) {
    return rootUrl() + String(path || '').replace(/^\//, '');
  }

  function uniqueUrls(urls) {
    var seen = {};
    return urls.filter(function (url) {
      if (!url || seen[url]) return false;
      seen[url] = true;
      return true;
    });
  }

  function normalizeCartAddUrl(form) {
    var action = form && form.getAttribute('action') ? form.getAttribute('action') : ajaxUrl('cart/add');
    var url = new URL(action, window.location.origin);
    url.pathname = url.pathname.replace(/\/cart\/add\/?$/, '/cart/add.js');
    if (url.pathname.indexOf('/cart/add.js') === -1 && url.pathname.indexOf('/cart/add') !== -1) {
      url.pathname = url.pathname.replace('/cart/add', '/cart/add.js');
    }
    return url.pathname + url.search;
  }

  function safeJsonFromResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var contentType = response.headers && response.headers.get ? (response.headers.get('content-type') || '') : '';
      var looksLikeHtml = /^\s*</.test(text);

      if (!response.ok) {
        if (looksLikeHtml) {
          var htmlStatusError = new Error(fallbackMessage || 'Request returned HTML instead of JSON.');
          htmlStatusError.isHtmlResponse = true;
          throw htmlStatusError;
        }

        if (text) {
          try {
            var errorData = JSON.parse(text);
            throw new Error(errorData.description || errorData.message || fallbackMessage || 'Request failed.');
          } catch (parseError) {
            if (parseError && parseError.message && parseError.message !== 'Unexpected end of JSON input') throw parseError;
          }
        }
        throw new Error(fallbackMessage || 'Request failed.');
      }

      if (!text) return {};
      if (contentType.indexOf('application/json') === -1 && looksLikeHtml) {
        var htmlError = new Error(fallbackMessage || 'Request returned HTML instead of JSON.');
        htmlError.isHtmlResponse = true;
        throw htmlError;
      }

      try {
        return JSON.parse(text);
      } catch (error) {
        throw new Error(fallbackMessage || 'Unable to read cart response.');
      }
    });
  }

  function fetchShopifyJson(urls, options, fallbackMessage) {
    var list = uniqueUrls(Array.isArray(urls) ? urls : [urls]);
    var index = 0;

    function attempt() {
      var url = list[index];
      index += 1;

      return fetchJson(url, options).then(function (response) {
        return safeJsonFromResponse(response, fallbackMessage);
      }).catch(function (error) {
        if (index < list.length && (error.isHtmlResponse || /HTML instead of JSON|Request failed|Cart unavailable/.test(error.message || ''))) {
          return attempt();
        }
        throw error;
      });
    }

    return attempt();
  }

  function isCartPage() {
    var root = rootUrl().replace(/\/$/, '');
    var path = window.location.pathname.replace(/\/$/, '');
    return document.body && (
      document.body.classList.contains('template-cart') ||
      path === root + '/cart' ||
      path === '/cart'
    );
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0);
    var value = amount / 100;
    var code = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var fractionDigits = amount % 100 === 0 ? 0 : 2;

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: code,
        currencyDisplay: 'symbol',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(fractionDigits);
    }
  }

  function fetchJson(url, options) {
    var fetchOptions = options || {};
    fetchOptions.credentials = 'same-origin';

    if (window.AbortController) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () {
        controller.abort();
      }, 12000);

      fetchOptions.signal = controller.signal;

      return fetch(url, fetchOptions).finally(function () {
        window.clearTimeout(timeout);
      });
    }

    return fetch(url, fetchOptions);
  }

  function getPopup() {
    return document.querySelector(SELECTORS.popup);
  }

  function openPopup(message) {
    var popup = getPopup();
    if (!popup) return;

    var messageEl = popup.querySelector(SELECTORS.message);
    if (messageEl) {
      if (message) {
        messageEl.textContent = message;
        messageEl.hidden = false;
        messageEl.removeAttribute('hidden');
      } else {
        messageEl.textContent = '';
        messageEl.hidden = true;
        messageEl.setAttribute('hidden', 'hidden');
      }
    }

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    if (!isCartPage()) document.body.classList.add('smart-cart-drawer-open');
    suppressNativeCartNotice();
  }

  function closePopup() {
    var popup = getPopup();
    if (!popup) return;

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('smart-cart-drawer-open');
  }

  function updateCartCount(cart) {
    if (!cart) return;

    var count = cart.item_count || 0;
    var selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.cart-count-bubble span',
      '#cart-icon-bubble span',
      '.header__cart-count',
      '[data-header-cart-count]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-count', count);
      });
    });

    document.querySelectorAll('a[aria-label^="Cart"][href*="/cart"]').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart, ' + count + ' ' + (count === 1 ? 'item' : 'items'));
    });
  }

  function currentCartCount() {
    var cartLink = document.querySelector('a[aria-label^="Cart"][href*="/cart"]');
    var labelMatch = cartLink && (cartLink.getAttribute('aria-label') || '').match(/Cart,\s*(\d+)/i);
    if (labelMatch) return Number(labelMatch[1]);

    var countEl = document.querySelector('[data-cart-count], .cart-count, .cart-count-bubble span, #cart-icon-bubble span, .header__cart-count, [data-header-cart-count]');
    var count = countEl ? parseInt(countEl.getAttribute('data-count') || countEl.textContent, 10) : NaN;
    return Number.isFinite(count) ? count : null;
  }

  function updateCartCountOptimistically(previousCount, addedQuantity) {
    if (!Number.isFinite(previousCount) || !Number.isFinite(addedQuantity) || addedQuantity <= 0) return;
    updateCartCount({ item_count: previousCount + addedQuantity });
  }

  function itemOptionsHtml(item) {
    var html = '';

    if (item.options_with_values && item.options_with_values.length) {
      html += item.options_with_values.map(function (option) {
        if (!option || !option.value || option.value === 'Default Title') return '';
        var name = option.name && option.name !== 'Title' ? option.name + ': ' : '';
        return '<div class="smart-cart-drawer__item-option">' + escapeHtml(name + option.value) + '</div>';
      }).join('');
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<div class="smart-cart-drawer__item-option">' + escapeHtml(item.variant_title) + '</div>';
    }

    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        if (!item.properties[key] || key.charAt(0) === '_') return;
        html += '<div class="smart-cart-drawer__item-option">' + escapeHtml(key + ': ' + item.properties[key]) + '</div>';
      });
    }

    return html;
  }

  function centsValue(value) {
    var number = Number(value || 0);
    return Number.isFinite(number) ? number : 0;
  }

  function getItemUnitPrice(item) {
    if (!item) return 0;
    if (typeof item.final_price !== 'undefined') return centsValue(item.final_price);
    // Show the product unit price before any manual/automatic cart discount.
    // Do not show coupon-discounted unit prices in the cart drawer.
    if (typeof item.original_price !== 'undefined' && centsValue(item.original_price) > 0) return centsValue(item.original_price);
    if (typeof item.price !== 'undefined' && centsValue(item.price) > 0) return centsValue(item.price);
    if (item.quantity && typeof item.original_line_price !== 'undefined') {
      return Math.round(centsValue(item.original_line_price) / Math.max(1, Number(item.quantity) || 1));
    }
    if (item.quantity && typeof item.line_price !== 'undefined') {
      return Math.round(centsValue(item.line_price) / Math.max(1, Number(item.quantity) || 1));
    }
    return 0;
  }

  function getItemLineTotal(item) {
    if (!item) return 0;
    // Line total shown in cart totals excludes checkout discount/coupon reductions.
    return getItemUnitPrice(item) * Math.max(1, Number(item.quantity) || 1);
  }

  function getInitialUnitCompareAt(item) {
    var unit = getItemUnitPrice(item);
    var compareAt = 0;

    if (item && typeof item.original_price !== 'undefined') compareAt = centsValue(item.original_price);
    if (item && typeof item.price !== 'undefined') compareAt = Math.max(compareAt, centsValue(item.price));

    return compareAt > unit ? compareAt : 0;
  }

  function itemUnitPriceHtml(item, currency) {
    var unit = getItemUnitPrice(item);
    var compareAt = getInitialUnitCompareAt(item);
    var compareHtml = compareAt > unit
      ? '<s class="smart-cart-drawer__item-unit-compare" data-smart-cart-unit-compare>' + formatMoney(compareAt, currency) + '</s>'
      : '<s class="smart-cart-drawer__item-unit-compare" data-smart-cart-unit-compare hidden></s>';

    return '<div class="smart-cart-drawer__item-unit-price">' +
      '<span class="smart-cart-drawer__item-unit-current" data-smart-cart-unit-current>' + formatMoney(unit, currency) + '</span>' +
      compareHtml +
    '</div>';
  }

  function itemLineTotalHtml(item, currency) {
    return '';
  }

  function getProductHandleFromItem(item) {
    var url = item && item.url ? item.url : '';
    if (!url) return '';

    try {
      var parsed = new URL(url, window.location.origin);
      var parts = parsed.pathname.split('/').filter(Boolean);
      var productsIndex = parts.indexOf('products');
      if (productsIndex !== -1 && parts[productsIndex + 1]) return decodeURIComponent(parts[productsIndex + 1]);
    } catch (error) {}

    var match = url.match(/\/products\/([^?/#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function fetchProductJsonByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (productJsonCache[handle]) return productJsonCache[handle];

    productJsonCache[handle] = fetchShopifyJson([rootUrl() + 'products/' + encodeURIComponent(handle) + '.js', '/products/' + encodeURIComponent(handle) + '.js'], {
      method: 'GET',
      headers: { 'Accept': 'application/json' }
    }, 'Product unavailable')
      .catch(function () { return null; });

    return productJsonCache[handle];
  }

  function updateCartCompareTotals(compareTotal, currentTotal, currency) {
    var popup = getPopup();
    if (!popup) return;

    var compareEl = popup.querySelector(SELECTORS.compareTotal);
    var savingsEl = popup.querySelector(SELECTORS.savings);
    var savings = Math.max(0, Number(compareTotal || 0) - Number(currentTotal || 0));

    if (compareEl) {
      if (compareTotal > currentTotal && savings > 0) {
        compareEl.textContent = formatMoney(compareTotal, currency);
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.setAttribute('hidden', 'hidden');
      }
    }

    if (savingsEl) {
      if (savings > 0) {
        savingsEl.textContent = '-' + formatMoney(savings, currency);
        savingsEl.hidden = false;
        savingsEl.removeAttribute('hidden');
      } else {
        savingsEl.textContent = '';
        savingsEl.hidden = true;
        savingsEl.setAttribute('hidden', 'hidden');
      }
    }
  }

  function hydrateCompareAtPrices(items, currency, cart) {
    var popup = getPopup();
    if (!popup || !items || !items.length) return;

    var currentTotal = cart
      ? getCartDisplayTotal(cart)
      : items.reduce(function (sum, item) { return sum + getItemLineTotal(item); }, 0);

    var fallbackCompareTotal = currentTotal;

    var compareTotal = 0;
    var pending = items.map(function (item, index) {
      var unit = getItemUnitPrice(item);
      var quantity = Math.max(1, Number(item.quantity) || 1);
      var handle = getProductHandleFromItem(item);
      var variantId = String(item.variant_id || item.id || '');
      var line = index + 1;
      var row = popup.querySelector('[data-smart-cart-line="' + line + '"]');

      function useUnitCompare(compareAt) {
        compareAt = centsValue(compareAt);
        var compareUnit = compareAt > unit ? compareAt : unit;
        compareTotal += compareUnit * quantity;

        if (!row) return;
        var compareEl = row.querySelector('[data-smart-cart-unit-compare]');
        if (!compareEl) return;

        if (compareAt > unit) {
          compareEl.textContent = formatMoney(compareAt, currency);
          compareEl.hidden = false;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
          compareEl.setAttribute('hidden', 'hidden');
        }
      }

      if (!handle || !variantId) {
        useUnitCompare(getInitialUnitCompareAt(item));
        return Promise.resolve();
      }

      return fetchProductJsonByHandle(handle).then(function (product) {
        if (!product || !product.variants || !product.variants.length) {
          useUnitCompare(getInitialUnitCompareAt(item));
          return;
        }

        var variant = product.variants.find(function (candidate) {
          return String(candidate.id) === variantId;
        });

        useUnitCompare(variant ? variant.compare_at_price : getInitialUnitCompareAt(item));
      }).catch(function () {
        useUnitCompare(getInitialUnitCompareAt(item));
      });
    });

    Promise.all(pending).then(function () {
      if (fallbackCompareTotal > compareTotal) compareTotal = fallbackCompareTotal;
      updateCartCompareTotals(0, currentTotal, currency);
    });
  }

  function discountRowsHtml(cart, currency) {
    var rows = [];
    var applied = 0;

    function addDiscountRow(label, amount) {
      amount = Number(amount || 0);
      if (amount <= 0) return;

      rows.push({
        label: label || 'Discount',
        amount: amount
      });
    }

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        addDiscountRow(allocation.discount_application.title === 'BF360GIFT' ? 'Free Spin Vortex' : allocation.discount_application.title, allocation.amount);
      });
    });

    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach(function (discount) {
        var amount = Number(discount.total_allocated_amount || 0);
        if (amount <= 0) return;

        applied += amount;

        var title = discount.title || '';
        var label = title && title.toLowerCase() !== 'discount'
          ? 'Discount (' + title + ')'
          : 'Discount';

        addDiscountRow(label, amount);
      });
    }



    return rows.map(function (row) {
      return '<div class="smart-cart-drawer__discount-row"><span>' + escapeHtml(row.label) + '</span><strong>-' + formatMoney(row.amount, currency) + '</strong></div>';
    }).join('');
  }

  function getCartDisplayTotal(cart) {
    return cart ? Number(cart.total_price) || 0 : 0;
  }

  function renderCartTotals(cart, currency) {
    var popup = getPopup();
    if (!popup || !cart) return;

    var subtotalEl = popup.querySelector(SELECTORS.subtotal);
    var discountsEl = popup.querySelector(SELECTORS.discounts);
    var totalEl = popup.querySelector(SELECTORS.total);
    var totalRow = popup.querySelector(SELECTORS.totalRow);
    var displayTotal = getCartDisplayTotal(cart);

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price, currency);
    if (totalEl) totalEl.textContent = formatMoney(displayTotal, currency);

    updateCartCompareTotals(0, displayTotal, currency);

    if (discountsEl) {
      discountsEl.innerHTML = discountRowsHtml(cart, currency);
      discountsEl.hidden = !discountsEl.innerHTML;
      if (discountsEl.innerHTML) discountsEl.removeAttribute('hidden');
    }

    if (totalRow) totalRow.hidden = false;
  }

  function renderCart(cart) {
    var popup = getPopup();
    if (!popup || !cart) return;

    var itemsEl = popup.querySelector(SELECTORS.items);
    var currency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    renderCartTotals(cart, currency);
    if (!itemsEl) return;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="smart-cart-drawer__empty">Your cart is empty.</div>';
      hideRecommendations();
      closePopup();
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var title = item.product_title || item.title || 'Product';
      var url = item.url || rootUrl() + 'cart';
      var line = index + 1;
      var image = item.image
        ? '<img src="' + item.image + '" alt="' + escapeHtml(title) + '" loading="lazy">'
        : '';

      return (
        '<div class="smart-cart-drawer__item" data-smart-cart-line="' + line + '">' +
          '<button class="smart-cart-drawer__remove" type="button" data-smart-cart-qty-action="remove" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Remove ' + escapeHtml(title) + '">×</button>' +
          '<a class="smart-cart-drawer__item-image" href="' + url + '">' + image + '</a>' +
          '<div class="smart-cart-drawer__item-main">' +
            '<a class="smart-cart-drawer__item-title" href="' + url + '">' + escapeHtml(title) + '</a>' +
            itemOptionsHtml(item) +
            itemUnitPriceHtml(item, currency) +
            '<div class="smart-cart-drawer__item-controls" aria-label="Quantity controls">' +
              '<button class="smart-cart-drawer__qty-button" type="button" data-smart-cart-qty-action="minus" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
              '<span class="smart-cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button class="smart-cart-drawer__qty-button" type="button" data-smart-cart-qty-action="plus" data-line="' + line + '" data-quantity="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          itemLineTotalHtml(item, currency) +
        '</div>'
      );
    }).join('');

    hydrateCompareAtPrices(cart.items, currency, cart);
  }

  function renderCartLoadError(message) {
    var popup = getPopup();
    if (!popup) return;

    var itemsEl = popup.querySelector(SELECTORS.items);
    var subtotalEl = popup.querySelector(SELECTORS.subtotal);
    var totalEl = popup.querySelector(SELECTORS.total);
    var compareTotalEl = popup.querySelector(SELECTORS.compareTotal);
    var savingsEl = popup.querySelector(SELECTORS.savings);
    var discountsEl = popup.querySelector(SELECTORS.discounts);
    var totalRowEl = popup.querySelector(SELECTORS.totalRow);

    if (itemsEl) {
      itemsEl.innerHTML = (
        '<div class="smart-cart-drawer__recovery" role="status">' +
          '<p>' + escapeHtml(message || 'We could not refresh the cart details yet.') + '</p>' +
          '<div class="smart-cart-drawer__recovery-actions">' +
            '<button type="button" data-smart-cart-retry>Try again</button>' +
            '<a href="' + rootUrl() + 'cart">View cart</a>' +
          '</div>' +
        '</div>'
      );
    }
    if (subtotalEl) subtotalEl.textContent = '—';
    if (totalEl) totalEl.textContent = '—';
    if (compareTotalEl) {
      compareTotalEl.textContent = '';
      compareTotalEl.hidden = true;
      compareTotalEl.setAttribute('hidden', 'hidden');
    }
    if (savingsEl) {
      savingsEl.textContent = '';
      savingsEl.hidden = true;
      savingsEl.setAttribute('hidden', 'hidden');
    }
    if (discountsEl) {
      discountsEl.innerHTML = '';
      discountsEl.hidden = true;
      discountsEl.setAttribute('hidden', 'hidden');
    }
    if (totalRowEl) totalRowEl.hidden = true;
    hideRecommendations();
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function refreshCart(maxAttempts) {
    var attempts = Math.max(1, Number(maxAttempts) || 1);

    function attempt(attemptIndex) {
      return fetchShopifyJson([ajaxUrl('cart.js'), '/cart.js'], {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Cache-Control': 'no-cache'
        }
      }, 'Cart unavailable')
        .then(function (cart) { return window.SmartBFCM ? window.SmartBFCM.reconcile(cart, true) : cart; })
        .then(function (cart) {
          renderCart(cart);
          updateCartCount(cart);
          return cart;
        })
        .catch(function (error) {
          if (attemptIndex + 1 >= attempts) throw error;
          return wait(250 * Math.pow(2, attemptIndex)).then(function () {
            return attempt(attemptIndex + 1);
          });
        });
    }

    return attempt(0);
  }

  function addedQuantityFromPayload(payload) {
    if (!payload || !payload.items || !payload.items.length) return 1;
    return payload.items.reduce(function (total, item) {
      return total + Math.max(1, Number(item && item.quantity) || 1);
    }, 0);
  }

  function addFailureMessage(error) {
    var message = error && error.message ? error.message : '';
    if (!message || /failed to fetch|networkerror|abort|load failed/i.test(message)) {
      return 'We could not confirm the add. Please check your cart before trying again.';
    }
    return message;
  }

  function finishSuccessfulAdd(productId, previousCount, addedQuantity) {
    return refreshCart(3)
      .then(function () {
        openPopup();
        loadRecommendations(productId);
      })
      .catch(function () {
        updateCartCountOptimistically(previousCount, addedQuantity);
        renderCartLoadError('Item added. The cart details are taking longer to load.');
        openPopup();
      });
  }

  function handleAddRequestFailure(error) {
    var message = addFailureMessage(error);

    return refreshCart(2)
      .then(function () {
        openPopup(message);
      })
      .catch(function () {
        renderCartLoadError('We could not confirm the add or refresh the cart details.');
        openPopup(message);
      });
  }

  function dispatchCartAddResult(status, form, trigger, error) {
    try {
      document.dispatchEvent(new CustomEvent('smart360:cart-add-result', {
        detail: {
          status: status,
          form: form || null,
          trigger: trigger || null,
          errorReason: status === 'failed' ? addFailureMessage(error) : ''
        }
      }));
    } catch (dispatchError) {
      // Cart behavior must remain independent from optional diagnostics.
    }
  }


  function setLineLoading(line, isLoading) {
    var popup = getPopup();
    if (!popup || !line) return;

    var row = popup.querySelector('[data-smart-cart-line="' + line + '"]');
    if (!row) return;

    row.classList.toggle('is-updating', !!isLoading);
    row.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    row.querySelectorAll('[data-smart-cart-qty-action]').forEach(function (button) {
      button.disabled = !!isLoading;
      if (isLoading) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
  }

  function setAllQtyButtonsDisabled(isDisabled) {
    var popup = getPopup();
    if (!popup) return;

    popup.querySelectorAll('[data-smart-cart-qty-action]').forEach(function (button) {
      button.disabled = !!isDisabled;
      if (isDisabled) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
  }

  function changeCartLine(line, quantity) {
    if (!line || isChanging) return Promise.resolve(null);

    var nextQuantity = Math.max(0, Number(quantity) || 0);
    isChanging = true;
    setLineLoading(line, true);
    setAllQtyButtonsDisabled(true);

    return fetchShopifyJson([ajaxUrl('cart/change.js'), '/cart/change.js'], {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: Number(line), quantity: nextQuantity })
    }, 'Unable to update cart.')
      .then(function (cart) { return window.SmartBFCM ? window.SmartBFCM.reconcile(cart, false) : cart; })
      .then(function (cart) {
        renderCart(cart);
        updateCartCount(cart);
        return cart;
      })
      .catch(function (error) {
        openPopup(error.message || 'Unable to update cart.');
        return null;
      })
      .finally(function () {
        setLineLoading(line, false);
        setAllQtyButtonsDisabled(false);
        isChanging = false;
      });
  }

  function getRecommendationsSettings() {
    return { enabled: false, limit: 0, mode: 'off' };
  }

  function hideRecommendations() {
    var popup = getPopup();
    if (!popup) return;
    var wrap = popup.querySelector(SELECTORS.recommendationsWrap);
    var grid = popup.querySelector(SELECTORS.recommendationsGrid);
    var settings = getRecommendationsSettings();
    if (wrap) wrap.hidden = true;
    if (grid && settings.mode !== 'manual') grid.innerHTML = '';
  }

  function showManualRecommendations() {
    var popup = getPopup();
    if (!popup) return;

    var settings = getRecommendationsSettings();
    var wrap = popup.querySelector(SELECTORS.recommendationsWrap);
    var grid = popup.querySelector(SELECTORS.recommendationsGrid);

    if (!settings.enabled || !wrap || !grid) {
      hideRecommendations();
      return;
    }

    var cards = grid.querySelectorAll('[data-smart-cart-manual-recommendation-card]');
    if (!cards.length) {
      hideRecommendations();
      return;
    }

    cards.forEach(function (card, index) {
      card.hidden = index >= settings.limit;
    });

    wrap.hidden = false;
  }

  function productImageHtml(product) {
    var image = product && (product.featured_image || (product.images && product.images[0]));
    var src = '';

    if (typeof image === 'string') {
      src = image;
    } else if (image && typeof image === 'object') {
      src = image.url || image.src || '';
    }

    if (!src) return '';
    return '<img src="' + src + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy">';
  }

  function renderRecommendations(products) {
    var popup = getPopup();
    if (!popup) return;

    var settings = getRecommendationsSettings();
    var wrap = popup.querySelector(SELECTORS.recommendationsWrap);
    var grid = popup.querySelector(SELECTORS.recommendationsGrid);

    if (!settings.enabled || !wrap || !grid || !products || !products.length) {
      hideRecommendations();
      return;
    }

    grid.innerHTML = products.slice(0, settings.limit).map(function (product) {
      var price = product.price_min || product.price || 0;
      var currency = product.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var url = product.url || '#';

      return (
        '<a class="smart-cart-drawer__recommendation" href="' + url + '">' +
          '<span class="smart-cart-drawer__recommendation-image">' + productImageHtml(product) + '</span>' +
          '<span class="smart-cart-drawer__recommendation-main">' +
            '<span class="smart-cart-drawer__recommendation-title">' + escapeHtml(product.title || 'Product') + '</span>' +
            '<span class="smart-cart-drawer__recommendation-price">' + formatMoney(price, currency) + '</span>' +
          '</span>' +
        '</a>'
      );
    }).join('');

    wrap.hidden = false;
  }

  function loadRecommendations(productId) {
    var settings = getRecommendationsSettings();
    if (!settings.enabled) {
      hideRecommendations();
      return Promise.resolve([]);
    }

    if (settings.mode === 'manual') {
      showManualRecommendations();
      return Promise.resolve([]);
    }

    if (!productId) {
      hideRecommendations();
      return Promise.resolve([]);
    }

    var url = rootUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + settings.limit + '&intent=complementary&_=' + Date.now();

    return fetchShopifyJson([url], { headers: { 'Accept': 'application/json' } }, 'Recommendations unavailable')
      .then(function (data) {
        var products = data && data.products ? data.products : [];
        renderRecommendations(products);
        return products;
      })
      .catch(function () {
        hideRecommendations();
        return [];
      });
  }

  function shouldSkipElement(el) {
    if (!el) return true;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return true;
    if (el.closest('[data-smart-cart-popup]')) return true;
    if (el.closest('.shopify-payment-button')) return true;
    if (el.closest('[data-shopify="payment-button"]')) return true;
    if (el.closest('[data-testid]')) return true;
    if (el.closest('[data-smart-pdp-buy-now]')) return true;
    if (el.closest('[name="checkout"], [formaction*="/checkout"]')) return true;
    if (el.matches('[data-smart-pdp-buy-now]')) return true;
    if (el.matches('[name="checkout"], [formaction*="/checkout"]')) return true;
    return false;
  }

  function isCartAddForm(form) {
    if (!form || !form.matches) return false;
    if (form.closest('.shopify-payment-button')) return false;
    if (form.closest('[data-shopify="payment-button"]')) return false;
    if (form.querySelector('[name="checkout"], [formaction*="/checkout"], .shopify-payment-button__button, [data-testid]')) return false;
    var action = form.getAttribute('action') || '';
    return form.matches('form[action*="/cart/add"]') || action.indexOf('/cart/add') !== -1;
  }

  function getClickedCartForm(event) {
    var trigger = event.target && event.target.closest
      ? event.target.closest('button, input[type="submit"], [type="submit"], a[href*="/cart/add"]')
      : null;

    if (!trigger || shouldSkipElement(trigger)) return null;
    if (trigger.matches('a[href*="/cart/add"]')) return null;

    var form = trigger.closest && trigger.closest('form');
    if (!isCartAddForm(form)) return null;

    var type = (trigger.getAttribute('type') || '').toLowerCase();
    if (type === 'button' && !trigger.matches('[name="add"], [data-smart-cart-submit], [data-smart-pdp-add-to-cart], .add-to-cart, .product-card-form button')) return null;

    form.__smartCartSubmitter = trigger;
    return form;
  }

  function getSubmittedCartForm(event) {
    var form = event.target;
    if (!isCartAddForm(form)) return null;
    if (form.dataset.smartPdpBuyNowMode === 'true') return null;

    var submitter = event.submitter || (document.activeElement && document.activeElement.closest ? document.activeElement.closest('button, input[type="submit"]') : null);
    if (submitter && shouldSkipElement(submitter)) return null;

    form.__smartCartSubmitter = submitter || null;
    return form;
  }

  function getLineItemProperties(form) {
    var properties = {};

    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/^properties\[(.*)\]$/);
      if (!match) return;
      if (input.type === 'checkbox' && !input.checked) return;
      if (input.type === 'radio' && !input.checked) return;
      if (input.value !== '') properties[match[1]] = input.value;
    });

    return properties;
  }



  function buildBaseCartPayload(form) {
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    var mainItem = {
      id: Number(variantInput.value),
      quantity: quantity,
      properties: getLineItemProperties(form)
    };

    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) mainItem.selling_plan = sellingPlanInput.value;

    return { items: [mainItem] };
  }

  function buildLogoAddonPayload(form) {
    var logoBox = document.querySelector('[data-smart-pdp-custom-logo]');
    if (!logoBox) return null;

    var checkbox = logoBox.querySelector('[data-smart-pdp-custom-logo-checkbox]');
    if (!checkbox || !checkbox.checked) return null;

    var addonVariantId = logoBox.getAttribute('data-addon-variant-id');
    if (!addonVariantId) return null;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    var properties = getLineItemProperties(form);
    var propertyName = logoBox.getAttribute('data-property-name') || 'Custom Logo Service';
    var propertyValue = logoBox.getAttribute('data-property-value') || 'Yes';
    var addonQuantityMode = logoBox.getAttribute('data-addon-quantity-mode') || 'per_order';
    var addonProductTitle = logoBox.getAttribute('data-addon-product-title') || 'Custom Logo Service';

    properties[propertyName] = propertyValue;

    var mainItem = {
      id: Number(variantInput.value),
      quantity: quantity,
      properties: properties
    };

    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) mainItem.selling_plan = sellingPlanInput.value;

    return {
      items: [
        mainItem,
        {
          id: Number(addonVariantId),
          quantity: addonQuantityMode === 'match_product_quantity' ? quantity : 1,
          properties: {
            'Service for': document.title || 'Photo booth product',
            'Added from': addonProductTitle
          }
        }
      ]
    };
  }


  function addSizeUpgradeToPayload(form, mainItem, addonItems, quantity) {
    var api = window.SmartSizeUpgrade;
    if (!api || typeof api.getSelectedAddon !== 'function') return;

    var selected = api.getSelectedAddon(form);
    if (!selected || !selected.addonVariantId) return;

    mainItem.properties = mainItem.properties || {};
    mainItem.properties[selected.mainPropertyName || 'Size Upgrade'] = selected.mainPropertyValue || 'Yes';

    addonItems.push({
      id: Number(selected.addonVariantId),
      quantity: selected.quantityMode === 'per_order' ? 1 : quantity,
      properties: selected.addonProperties || {}
    });
  }

  function addExtendedWarrantyToPayload(form, mainItem, addonItems, quantity) {
    var api = window.SmartExtendedWarranty;
    if (!api || typeof api.getSelectedAddon !== 'function') return;

    var selected = api.getSelectedAddon(form);
    if (!selected || !selected.addonVariantId) return;

    mainItem.properties = mainItem.properties || {};
    mainItem.properties[selected.mainPropertyName || 'Extended Warranty'] = selected.mainPropertyValue || 'Yes';

    addonItems.push({
      id: Number(selected.addonVariantId),
      quantity: selected.quantityMode === 'per_order' ? 1 : quantity,
      properties: selected.addonProperties || {}
    });
  }

  function addLogoUpgradeToPayload(form, mainItem, addonItems, quantity) {
    var logoBox = document.querySelector('[data-smart-pdp-custom-logo]');
    if (!logoBox) return;

    var checkbox = logoBox.querySelector('[data-smart-pdp-custom-logo-checkbox]');
    if (!checkbox || !checkbox.checked) return;

    var addonVariantId = logoBox.getAttribute('data-addon-variant-id');
    if (!addonVariantId) return;

    var propertyName = logoBox.getAttribute('data-property-name') || 'Custom Logo Service';
    var propertyValue = logoBox.getAttribute('data-property-value') || 'Yes';
    var addonQuantityMode = logoBox.getAttribute('data-addon-quantity-mode') || 'per_order';
    var addonProductTitle = logoBox.getAttribute('data-addon-product-title') || 'Custom Logo Service';

    mainItem.properties = mainItem.properties || {};
    mainItem.properties[propertyName] = propertyValue;

    addonItems.push({
      id: Number(addonVariantId),
      quantity: addonQuantityMode === 'match_product_quantity' ? quantity : 1,
      properties: {
        'Service for': document.title || 'Photo booth product',
        'Added from': addonProductTitle
      }
    });
  }

  function buildSmartAddonPayload(form) {
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    var mainItem = {
      id: Number(variantInput.value),
      quantity: quantity,
      properties: getLineItemProperties(form)
    };

    var sellingPlanInput = form.querySelector('[name="selling_plan"]');
    if (sellingPlanInput && sellingPlanInput.value) mainItem.selling_plan = sellingPlanInput.value;

    var addonItems = [];
    addLogoUpgradeToPayload(form, mainItem, addonItems, quantity);
    addSizeUpgradeToPayload(form, mainItem, addonItems, quantity);
    addExtendedWarrantyToPayload(form, mainItem, addonItems, quantity);

    if (!addonItems.length) return null;
    return { items: [mainItem].concat(addonItems) };
  }

  function getPurchaseButtons() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll(PURCHASE_BUTTON_SELECTOR));
    var seen = [];
    return buttons.filter(function (button) {
      if (!button || seen.indexOf(button) !== -1) return false;
      seen.push(button);
      return true;
    });
  }

  function setFormLoading(form, isLoading, activeButton) {
    if (!form) return;

    var buttons = getPurchaseButtons();
    if (activeButton && buttons.indexOf(activeButton) === -1) buttons.push(activeButton);

    buttons.forEach(function (button) {
      if (!button || button.closest('.shopify-payment-button')) return;

      if (isLoading) {
        if (!Object.prototype.hasOwnProperty.call(button.dataset, 'smartCartWasDisabled')) {
          button.dataset.smartCartWasDisabled = button.disabled ? 'true' : 'false';
        }

        button.disabled = true;

        if (button === activeButton) {
          button.classList.add('is-smart-loading');
          button.setAttribute('aria-busy', 'true');
        } else {
          button.classList.add('is-smart-locked');
          button.removeAttribute('aria-busy');
        }
      } else {
        button.disabled = button.dataset.smartCartWasDisabled === 'true';
        delete button.dataset.smartCartWasDisabled;
        button.classList.remove('is-smart-loading');
        button.classList.remove('is-smart-locked');
        button.removeAttribute('aria-busy');
      }
    });
  }

  function addFormToCart(form) {
    if (!form || form.dataset.smartCartProcessing === 'true' || isAdding) return;

    isAdding = true;
    form.dataset.smartCartProcessing = 'true';
    var activeButton = form.__smartCartSubmitter || form.querySelector('[data-smart-pdp-add-to-cart], [name="add"], button[type="submit"]');
    setFormLoading(form, true, activeButton);
    suppressNativeCartNotice();
    hideRecommendations();

    var cartPayload = buildSmartAddonPayload(form) || buildBaseCartPayload(form);

    if (!cartPayload || !cartPayload.items || !cartPayload.items.length) {
      setFormLoading(form, false);
      delete form.__smartCartSubmitter;
      delete form.dataset.smartCartProcessing;
      isAdding = false;
      openPopup('Please select a product option first.');
      return;
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(cartPayload)
    };
    var previousCount = currentCartCount();
    var addedQuantity = addedQuantityFromPayload(cartPayload);

    fetchShopifyJson([ajaxUrl('cart/add.js'), '/cart/add.js', normalizeCartAddUrl(form)], requestOptions, 'Unable to add item to cart.')
      .then(function (data) {
        var firstItem = data && data.items && data.items.length ? data.items[0] : data;
        var productId = firstItem && firstItem.product_id ? firstItem.product_id : null;

        return finishSuccessfulAdd(productId, previousCount, addedQuantity).then(function () {
          dispatchCartAddResult('success', form, activeButton);
        });
      }, function (error) {
        return handleAddRequestFailure(error).then(function () {
          dispatchCartAddResult('failed', form, activeButton, error);
        });
      })
      .finally(function () {
        setFormLoading(form, false);
        delete form.__smartCartSubmitter;
        delete form.dataset.smartCartProcessing;
        isAdding = false;
      });
  }

  function addLinkToCart(link) {
    if (!link || isAdding) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/cart/add') === -1) return;

    var url = new URL(href, window.location.origin);
    var id = url.searchParams.get('id');
    if (!id) return;

    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', url.searchParams.get('quantity') || '1');

    isAdding = true;
    suppressNativeCartNotice();
    hideRecommendations();
    var previousCount = currentCartCount();
    var addedQuantity = Math.max(1, Number(url.searchParams.get('quantity')) || 1);

    fetchShopifyJson([ajaxUrl('cart/add.js'), '/cart/add.js'], {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    }, 'Unable to add item to cart.')
      .then(function (item) {
        var productId = item && item.product_id ? item.product_id : null;

        return finishSuccessfulAdd(productId, previousCount, addedQuantity).then(function () {
          dispatchCartAddResult('success', null, link);
        });
      }, function (error) {
        return handleAddRequestFailure(error).then(function () {
          dispatchCartAddResult('failed', null, link, error);
        });
      })
      .finally(function () {
        isAdding = false;
      });
  }

  function interceptEvent(event, handler) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    handler();
  }

  function onCaptureClick(event) {
    if (isCartPage()) return;

    var retryButton = event.target && event.target.closest ? event.target.closest(SELECTORS.retry) : null;
    if (retryButton) {
      interceptEvent(event, function () {
        retryButton.disabled = true;
        retryButton.setAttribute('aria-busy', 'true');
        retryButton.textContent = 'Refreshing…';

        refreshCart(3)
          .then(function () {
            openPopup();
          })
          .catch(function () {
            renderCartLoadError();
            openPopup();
          });
      });
      return;
    }

    var qtyButton = event.target && event.target.closest ? event.target.closest(SELECTORS.qtyAction) : null;
    if (qtyButton) {
      interceptEvent(event, function () {
        var line = qtyButton.getAttribute('data-line');
        var quantity = parseInt(qtyButton.getAttribute('data-quantity'), 10) || 0;
        var action = qtyButton.getAttribute('data-smart-cart-qty-action');
        var nextQuantity = quantity;

        if (action === 'plus') nextQuantity = quantity + 1;
        else if (action === 'remove') nextQuantity = 0;
        else if (action === 'minus') nextQuantity = quantity <= 1 ? 0 : quantity - 1;

        changeCartLine(line, nextQuantity);
      });
      return;
    }

    var closeButton = event.target && event.target.closest ? event.target.closest(SELECTORS.close) : null;
    if (closeButton) {
      interceptEvent(event, closePopup);
      return;
    }

    var addLink = event.target && event.target.closest ? event.target.closest('a[href*="/cart/add"]') : null;
    if (addLink && !shouldSkipElement(addLink)) {
      interceptEvent(event, function () { addLinkToCart(addLink); });
      return;
    }

    var form = getClickedCartForm(event);
    if (!form) return;

    interceptEvent(event, function () { addFormToCart(form); });
  }

  function onCaptureSubmit(event) {
    if (isCartPage()) return;

    var form = getSubmittedCartForm(event);
    if (!form) return;

    interceptEvent(event, function () { addFormToCart(form); });
  }

  function suppressNativeCartNotice() {
    var nativeSelectors = [
      'cart-notification',
      '#cart-notification',
      '.cart-notification-wrapper',
      '.cart-notification',
      '.notification-bar',
      '.ajax-cart-notification',
      '.cart-toast',
      '[data-cart-notification]',
      '[id*="cart-notification"]',
      '[class*="cart-notification"]'
    ];

    nativeSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (el.closest(SELECTORS.popup)) return;
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.setAttribute('hidden', 'hidden');
        el.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function startNativeNoticeObserver() {
    if (mutationObserver || !document.body) return;

    mutationObserver = new MutationObserver(function () {
      suppressNativeCartNotice();
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }


  function resetPurchaseButtonState() {
    getPurchaseButtons().forEach(function (button) {
      if (!button) return;
      var wasDisabled = button.dataset.smartCartWasDisabled === 'true';
      if (Object.prototype.hasOwnProperty.call(button.dataset, 'smartCartWasDisabled')) {
        button.disabled = wasDisabled;
        delete button.dataset.smartCartWasDisabled;
      } else if (button.classList.contains('is-smart-loading') || button.classList.contains('is-smart-locked')) {
        button.disabled = button.getAttribute('aria-disabled') === 'true' || button.classList.contains('disabled');
      }
      button.classList.remove('is-smart-loading');
      button.classList.remove('is-smart-locked');
      button.removeAttribute('aria-busy');
    });

    document.querySelectorAll('form[data-smart-cart-processing="true"]').forEach(function (form) {
      delete form.dataset.smartCartProcessing;
      delete form.__smartCartSubmitter;
    });

    isAdding = false;
  }

  window.addEventListener('pageshow', resetPurchaseButtonState);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resetPurchaseButtonState();
  });

  window.addEventListener('click', onCaptureClick, true);
  window.addEventListener('submit', onCaptureSubmit, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closePopup();
  });

  document.addEventListener('DOMContentLoaded', function () {
    suppressNativeCartNotice();
    startNativeNoticeObserver();
  });
  window.SmartCartPopup = { showCart: function (cart) { renderCart(cart); updateCartCount(cart); openPopup(cart.bfcm_notice || ''); } };
})();
